export const VariantMapping: Record<Variants, Components> = {
	h1: "h1",
	h2: "h2",
	h3: "h3",
	h4: "h4",
	h5: "h5",
	h6: "h6",
	paragraph: "p",
	"paragraph-bold": "p",
	"paragraph-italic": "p",
	"paragraph-primary-extrabold": "p",
	"paragraph-primary-semibold": "p",
	"paragraph-primary": "p",
	"paragraph-primary-italic": "p",
};

export type Variants =
	| "h1"
	| "h2"
	| "h3"
	| "h4"
	| "h5"
	| "h6"
	| "paragraph"
	| "paragraph-bold"
	| "paragraph-italic"
	| "paragraph-primary-extrabold"
	| "paragraph-primary-semibold"
	| "paragraph-primary"
	| "paragraph-primary-italic";

type Components = "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "p" | "span";
